import type { PopupProps } from '../../../hooks/popup';

export type RevealScope = 'cell' | 'word' | 'all';
export type RevealUnit = 'casa' | 'letra';

export function revealMessage(scope: RevealScope, unit: RevealUnit): string {
  if (scope === 'all') return 'Revelar tudo zera sua pontuação e termina o jogo.';
  if (scope === 'word') return `Essas ${unit}s não vão valer pontos.`;
  return `Essa ${unit} não vai valer pontos.`;
}

interface RevealConfirmArgs {
  scope: RevealScope;
  unit: RevealUnit;
  title: string;
  onConfirm: () => void;
}

/** Popup (coruja do portal) que confirma antes de revelar. */
export function revealConfirm({ scope, unit, title, onConfirm }: RevealConfirmArgs): PopupProps {
  return {
    title,
    message: revealMessage(scope, unit),
    type: 'atencao',
    buttons: [
      { buttonText: 'Revelar', buttonFunction: onConfirm },
      { buttonText: 'Cancelar', isPurple: true },
    ],
  };
}
